import * as React from 'react';
import { IUnBookedOrderListItem } from '../Entities';
import * as Site from '../../../shared/Site';
import { Link } from 'react-router-dom';
import ProductPropertiesIcons from '../../propertyIcons/ProductPropertiesIcons';
import OrderListTableCell from '../../../components/common/OrderListTableCell';
import * as Features from '../../../shared/Features';
import * as ProductProperty from '../../../shared/ProductProperties';
import moment from 'moment';

interface UnBookedOrderListRowProps {
    key: number;
    order: IUnBookedOrderListItem;
    user: any;
}

const UnBookedOrderListRow = (props: UnBookedOrderListRowProps) => {
    const canViewOrder = Features.hasFeature(Features.ViewOrder, props.user);
    const orderLink = `/orders/${props.order.orderId}`;

    const productsToExclude = [ProductProperty.BlueSky, ProductProperty.InteriorBlueSky];

    let rowClass = Site.getOrderCssClass(props.order.site);
    if (props.order.isExpress) {
        rowClass += ' express';
    } else if (props.order.isExpressWeekend) {
        rowClass += ' express-weekend';
    } else if (props.order.isEarlyDelivery) {
        rowClass += ' early-delivery';
    }

    return (
        <tr className={rowClass}>
            <td>
                <Link to={`/ordercollections/${props.order.orderCollectionId}`}>
                    {props.order.orderCollectionNumber}
                </Link>
                :{props.order.orderNumber}
            </td>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink}>
                {props.order.brokerFirmName}
            </OrderListTableCell>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink}>
                {moment(props.order.createdAt).format('L LT')}
            </OrderListTableCell>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink}>
                {props.order.packageProduct}
            </OrderListTableCell>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink}>
                {props.order.address}, {props.order.city}
            </OrderListTableCell>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink} className="center">
                {props.order.preferredDate && (
                    <i
                        className="material-icons"
                        title={moment(props.order.preferredDate).format('L LT')}
                    >
                        schedule
                    </i>
                )}
            </OrderListTableCell>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink} className="center">
                {props.order.assignedUserName && (
                    <i
                        className={
                            'material-icons' +
                            (props.order.assignedUserId == props.user.details.id ? ' red' : '')
                        }
                        title={props.order.assignedUserName}
                    >
                        locked
                    </i>
                )}
            </OrderListTableCell>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink}>
                {props.order.isRead ? <i className="material-icons">check_circle</i> : ''}
            </OrderListTableCell>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink}>
                <ProductPropertiesIcons
                    properties={props.order.productProperties.filter((property) => {
                        return property.value !== productsToExclude.find((x) => x === property.value);
                    })}
                ></ProductPropertiesIcons>
            </OrderListTableCell>
        </tr>
    );
};

export default UnBookedOrderListRow;
